import * as actionTypes from "../constants/actionTypes";

export const setKeyBoardState = (state) => ({
    type: actionTypes.SAVE_KEYBOARD_STATE,
    payload: {
        state: state
    }
});

export const setUniversalKeyboardState = (state, selector) => ({
    type: actionTypes.SET_UNIVERSAL_KEYBOARD_STATE,
    payload: {
        state: state,
        selector: selector
    }
});

export const setKeyboardText = (text) => ({
    type: actionTypes.SET_KEYBOARD_TEXT,
    payload: {
        text: text
    }
});
